import ProtectedRouteError from './ProtectedRouteError'

export default ProtectedRouteError
